
export default {
	name: 'select2',
	handler: {
		init: function (element, valueAccessor) {
			let options = ko.toJS(valueAccessor()) || {};

			// Execute as soon as possible, but after the main thread finishes what it's busy with
			setTimeout(function () {
				$(element).select2(options);
			}, 0);
		}
	}
};
